import styled from "styled-components";
import Container from "@material-ui/core/Container";

const Wrapper = styled(Container)`
  margin-top: 90px;
  height: 100%;
  position: relative;
  min-height: 100vh;
  max-width: 1400px !important;

  .video-player-not-available {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .video-player-image {
    width: 350px;
  }

  .video__floater {
    position: fixed;
    height: 100px;
    top: -50px;
    width: 100%;
    left: 0;
    background: white;
    z-index: 1004;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.6, 1) 0ms;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    &.showFloater {
      top: 50px;
      transition: all 0.6s cubic-bezier(0.4, 0, 0.6, 1) 0ms;
    }
    .details__floater--wrapper {
      display: flex;
      margin-top: 20px;
      padding-left: 20px;
      .thumbnail {
        width: 40px;
        height: 40px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        border-radius: 3px;
      }
      .title {
        flex: 1;
        padding-left: 15px;
      }
    }
    .MuiButtonBase-root {
      float: right;
      color: ${(props) => props.theme.colors.primary.main};
      margin-right: 15px;
    }
  }

  .back__riff--toolbar {
    display: flex;
    .see-more-videos {
      flex: 1 1 auto;
      button {
        border: none;
        background-color: transparent;
        color: ${(props) => props.theme.colors.primary.main}
        font-size: 12px;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
        svg {
          color: ${(props) => props.theme.colors.primary.main}
        }
      }
    }
    .see-more-videos,
    .jump-to-riff {
      margin-bottom: 20px;
      a {
        color: ${(props) => props.theme.colors.primary.main}
        font-size: 12px;
        text-decoration: none;
        svg {
          color: ${(props) => props.theme.colors.primary.main};
        }
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .collection__wrapper {
    .collection-header {
      color: black;
      position: relative;
      font-size: 35px;
      padding-top: 30px;
      margin-bottom: 30px;
      color: rgba(0, 0, 0, 0.87);
      &::after {
        content: "";
        position: absolute;
        height: 1px;
        width: 100px;
        background-color: ${(props) => props.theme.colors.primary.main};
        bottom: -5px;
        left: 0;
      }

      &.trending {
        margin-top: 50px;
      }
    }
    .hot-collections {
      display: flex;
      justify-content: space-between;
      position: relative;

      .loading {
        transform: scale(0.3) !important;
        height: 100px;
      }
      .collection-image {
        height: 145px;
      }
      .hot-collection-root {
        width: calc((100% / 3) - 8px);
      }
    }

    .trending__wrapper {
      h2 {
        display: none;
      }
      .col-12 {
        padding-left: unset;
        padding-right: unset;
      }
      .video-thumbnail-container .thumb-overlay img {
        width: 100%;
      }
    }

    .flex {
      .result-item {
        max-width: 197px;
        min-width: 197px;
        margin: unset;

        .itemTitle a h3 {
          div {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }

  @media screen and (max-width: 991px) {
    margin-top: 60px;

    .root__grid {
      .MuiGrid-grid-md-4 {
        padding-top: 0;

        & > div:first-child {
          margin-top: 0;
        }
      }
    }
    .root__grid--mobile {
      .MuiGrid-grid-xs-12:first-child {
        padding-bottom: 0;
      }
      .MuiGrid-grid-xs-12:last-child {
        padding-top: 0;
      }
    }
    .collection__wrapper {
      clear: both;
      .collection-header {
        font-size: 21px;
        padding-top: 0;
        &::after {
          width: 90px;
        }
      }
      .hot-collections {
        flex-flow: row wrap;
        .collection-image {
          height: 108px;
        }
        .collection-list {
          border-bottom: 2px solid rgb(0, 163, 184);
          box-shadow: unset;
        }
      }

      .flex {
        .result-item {
          .itemTitle a h3 div {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
        }
      }
    }
    .search__button {
      width: 100%;
      height: 36px;
      margin-bottom: 10px;
      color: ${(props) => props.theme.colors.primary.main};
      border: 1px solid rgba(0, 0, 0, 0.12);
      margin-bottom: 50px;
      a {
        color: ${(props) => props.theme.colors.primary.main};
      }
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1230px) {
    .collection__wrapper {
      .flex {
        .result-item {
          min-width: 150px;
          max-width: 150px;
          .image-container {
            height: 100px;

            .thumb-overlay img {
              max-width: 150px;
              max-height: 100px;
            }
          }
          .itemTitle {
            .date__clearance {
              & > span:first-child {
                display: none;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1024px) {
    .video-player-image {
      width: 300px;
    }
  }
`;

export default Wrapper;
